module.exports = __webpack_public_path__ + "img/woocommerce-wordpress.c0e10f01.png";